import Const from '../config/const';

const setError = (errorCode, errorText, errorUrl, statusText) => ({
  type: Const.applicationError.error,
  errorCode,
  errorText,
  errorUrl,
  statusText
});

export const setApplicationError = ({
  errorCode, errorText, errorUrl, statusText
}) => (dispatch) => {
  dispatch(setError(errorCode, errorText, errorUrl, statusText));
};

const clearError = () => ({
  type: Const.applicationError.clearError
});

export const clearApplicationError = () => (dispatch) => {
  dispatch(clearError());
};
